import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NoticeService } from 'src/app/services/notice/notice.service';

@Component({
  selector: 'app-notice-circular',
  templateUrl: './notice-circular.component.html',
  styleUrls: ['./notice-circular.component.scss']
})
export class NoticeCircularComponent implements OnInit, OnDestroy {

  staticNotices = [
     {
      title: 'Induction Programme for Newly Admitted Students',
      description: 'This is to inform all newly admitted students that an Induction Programme will be held on Monday, 03 August 2026, to warmly welcome them to the college and familiarize them with the academic environment, rules, facilities, and various student support services.',
      date: '03 August 2026'
    },
    {
      title: 'PG Admissions 2026–27: Registration Deadline Extended till 7 August 2026',
      description: 'In continuation of the previous admission notice, online registration for admission to Postgraduate First-Year programmes (M.A., M.Com., M.Sc., etc.) in all Haryana Government Degree Colleges has been extended until 7 August 2026. Candidates who have not yet completed their registration are advised to avail of this extended opportunity and submit their applications within the revised deadline. Admission Portal: https://admissions.highereduhry.ac.in',
      date: '31 Jul 2026'
    },
    {
      title: 'Commencement of Academic Session 2026–27',
      description: 'All UG 1st, 3rd & 5th Semester and PG 3rd Semester students are hereby informed that the Academic Session 2026–27 will commence on 3 August 2026 (Monday). All students are required to report to the college by 9:00 a.m. sharp on the first day of the session. Students are advised to be punctual and attend their classes regularly from the very beginning of the academic session.',
      date: '31 Jul 2026'
    },
   
    {
      title: 'PG Admissions 2026–27: Registration Open till 26 July 2026',
      description: 'Online registration for admission to Postgraduate First-Year programmes (M.A., M.Com., M.Sc., etc.) in all Haryana Degree Colleges is open until 26 July 2026. Interested candidates are advised to complete their registration within the stipulated time. Admission Portal: https://admissions.highereduhry.ac.in',
      date: 'July 2026'

    },
    {
      title: 'Submission of Internship Completion Certificate',
      description: 'All second-year students across all UG streams must submit their Internship Completion Certificate to their mentors by July 15, 2026. Following this, a Viva Voce will be conducted for the mandatory 120-hour internship.',
      date: '09 Jun 2026'
    },
    {
      title: 'World Environment Day Celebration',
      description: 'The Red Ribbon Club and NSS Unit will observe World Environment Day through an oath-taking ceremony and a tree plantation drive. The programme aims to create awareness about environmental conservation and encourage students to adopt eco-friendly practices. All students are invited to participate and contribute towards building a greener and more sustainable future.',
      date: '05 Jun 2026'
    },
    {
      title: 'Yoga Fortnight Celebration',
      description: 'The Yoga Club in collaboration with the Department of Physical Education will organize Yoga Fortnight from 5 June to 15 June 2026. A series of yoga training sessions and awareness activities will be conducted for students to promote physical fitness, mental well-being, and a healthy lifestyle. All students are encouraged to participate actively in the programme.',
      date: '05 Jun 2026'
    }
  ];

  notices = [];
  private sub: Subscription;

  circulars = [
    {
      date: 'September 2026',
      title: '45-Day Winter Internship Program in AI and Machine Learning (2026), organised by the Indian Institute of Computing and Technology (IICT), New Delhi',
      link: 'assets/pdf/IICT_Winter Internship Program in AI and Machine Learning (2026).pdf',
      type: 'PDF'
    },
    {
      date: 'July 2026',
      title: 'Registration Open: 2-Day Helicopter Design Workshop & 3-Day AI Accelerate Boot Camp (BSERC)',
      link: 'assets/pdf/Helicopter Design Workshop & 3-Day AI Accelerate Boot Camp.pdf',
      type: 'PDF'
    },
    {
      date: 'Current',
      title: 'Guidelines for Internships in Undergraduate and Integrated Programmes Conducted by University Teaching Departments and Affiliated Colleges in Accordance with NEP 2020',
      link: 'assets/pdf/CDLU- Internship Guidelines as Per NEP-2020.pdf',
      type: 'PDF'
    },
    {
      date: 'May 2026',
      title: 'Final Date Sheet for Undergraduate Programmes- May 2026',
      link: 'assets/pdf/Final Date-sheet-UG- May-2026.pdf',
      type: 'PDF'
    },
    {
      date: 'May 2026',
      title: 'Final Date Sheet for Post Graduate Programmes- May 2026',
      link: 'assets/pdf/Final Date-sheet of PG Pragrammes- May-2026.pdf',
      type: 'PDF'
    }
   
  ];

  constructor(private noticeService: NoticeService) { }

  ngOnInit(): void {
    this.sub = this.noticeService.getNoticesList().snapshotChanges().subscribe((list) => {
      const items = list.map((item) => {
        const val = item.payload.val() || {};
        let desc = val.desc || val.description || val.details || '';
        return {
          title: val.title || val.name || 'Untitled Notice',
          description: desc,
          date: val.date || val.monthYear || 'Current'
        };
      });

      this.notices = [...items.reverse(), ...this.staticNotices];
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
